type SectionIntroProps = {
  eyebrow: string;
  title: string;
  description: string;
};

export function SectionIntro({
  eyebrow,
  title,
  description,
}: SectionIntroProps) {
  return (
    <header className="section-intro">
      <p className="section-intro__eyebrow">{eyebrow}</p>
      <h2 className="section-intro__title">{title}</h2>
      <p className="section-intro__description">{description}</p>
    </header>
  );
}
